import { userManager } from './oicd'
import { useEffect } from 'react'
import OverlayLoader from 'components/ui/OverlayLoader'

export default function Logout() {
  useEffect(() => {
    const handleLogout = async () => {
      await userManager.signinRedirect()
    }
    handleLogout()
  }, [])
  return <OverlayLoader visible={true} />
}
